"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createStore_1 = require("./createStore");

var applyMiddleware_1 = require("./applyMiddleware");

exports.applyMiddleware = applyMiddleware_1.default;

var combineReducers_1 = require("./combineReducers");

exports.combineReducers = combineReducers_1.default;

var connect_1 = require("./connect");

exports.connect = connect_1.default;

var connectWithStore_1 = require("./connectWithStore");

exports.connectWithStore = connectWithStore_1.default;

var createUniqueStore_1 = require("./createUniqueStore");

exports.createUniqueStore = createUniqueStore_1.default;

var connectWithStore_2 = require("./connectWithStore");

exports.createProvider = connectWithStore_2.default;

var Provider_1 = require("./Provider");

exports.Provider = Provider_1.default;
exports.default = createStore_1.default;